<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SeleccionPosicion></SeleccionPosicion>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SeleccionPosicion from '../components/SeleccionPosicion.vue';
export default {
    name: 'SelectPositionView',
    components: {
        ColumnaIzquierda,
        SeleccionPosicion,
    }
}
</script>